<app-header [isLogged]="isLogged$ | async"></app-header>

<app-header-banner *ngIf="(isMobile$ | async) === false" class="header-banner">
  <app-search-header></app-search-header>
</app-header-banner>

<main id="layout-main" class="jobs-main container">
  <app-breadcrumb
    *ngIf="breadcrumbSegments$ | async as breadcrumbSegments"
    [segments]="breadcrumbSegments"
    [isLogged]="isLogged$ | async"
    [isMobile]="isMobile$ | async"
    class="breadcrumb"
  ></app-breadcrumb>

  <div class="job-content">
    <div class="jobs-main__aux-outlet" [hidden]="(jobs$ | async)?.length < 2 || !showMenu">
      <div class="jobs-main__aux-outlet-inner">
        <router-outlet name="aux"></router-outlet>
      </div>
    </div>

    <div class="jobs-main__outlet">
      <router-outlet></router-outlet>
    </div>

    <div
      *ngIf="showMedia && jobLoaded && wizbiiDomain && wizbiiDomain !== 'undefined' && locale === LocaleEnum.fr_FR"
      class="jobs-main__media-wrapper"
      appResizeObserver
      (resizeEv)="onResize($event)"
    >
      <wiz-media
        [attr.department]="jobLocalization || ''"
        [attr.domain]="wizbiiDomain"
        cookiekey="wizbii_tokens"
        spot="VerticalBannerWizbii"
      ></wiz-media>
    </div>
  </div>
</main>

<app-footer [isLogged]="false"></app-footer>
